import { createSlice } from '@reduxjs/toolkit';
import { GlobalConfigurationsData } from '@upstart/harmony/lib/legos/globalConfigurationTypes';
import { setFetching } from '../utils';
import { fetchGlobalConfigurations } from './thunks';

export const globalConfigurationsSlice = createSlice({
  name: 'globalConfigurations',
  initialState: {
    fetching: false,
    globalConfigurations: null as GlobalConfigurationsData | null,
  },
  reducers: {
    clear: (state) => {
      state.globalConfigurations = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchGlobalConfigurations.pending, (state) => {
      state.fetching = true;
      state.globalConfigurations = null;
    });
    builder.addCase(fetchGlobalConfigurations.rejected, setFetching(false));
    builder.addCase(fetchGlobalConfigurations.fulfilled, (state, action) => {
      state.fetching = false;
      state.globalConfigurations = action.payload;
    });
  },
});
